import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { toast } from "sonner";

export default function AuthCallback() {
  const navigate = useNavigate();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) { navigate("/", { replace: true }); return; }
    const session_id = decodeURIComponent(m[1]);
    (async () => {
      try {
        const { data } = await api.post("/auth/session", { session_id }, { withCredentials: true });
        toast.success(`Welcome, ${data.user.name || data.user.email}`);
        // clean the hash from URL
        window.history.replaceState({}, "", "/admin");
        navigate("/admin", { replace: true, state: { user: data.user } });
      } catch {
        toast.error("Sign-in failed. Please try again.");
        navigate("/", { replace: true });
      }
    })();
  }, [navigate]);

  return (
    <div className="max-w-[560px] mx-auto p-16 text-center fade-up" data-testid="auth-callback">
      <div className="tag-red inline-block">Signing you in</div>
      <h1 className="font-display text-4xl mt-3">One moment…</h1>
      <p className="font-body mt-3 opacity-70">Verifying with Google.</p>
    </div>
  );
}
